<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      ref="tablaInformes"
      :titulo="$t ('Informes')"
      icono="mdi-file-outline"
      tabla="inf"
      :campos="['id_inf-', 'des+', 'ins+', 'parapl', 'ref', 'for', 'tam-', 'corele-', 'id_ope-', 'fechorsol', 'fechordis-', 'est-', 'lei-']"
      :campos-filtrables="['fechorsol']"
      :parametros="parametros"
      :titulo-crud="$t ('informe')"
      busqueda-rapida
      permitir-modificar
      permitir-eliminar
      dense
      :filasPorPagina="50"
      :evento-doble-click-fila="abrirInforme"
    >
      <template v-slot:derecha-titulo>
        <v-btn small rounded color="primary" dark class="ml-3 mr-2 mt-n2" @click="nuevoInforme">
          <v-icon small>mdi-plus</v-icon>
        </v-btn>
      </template>

      <template v-slot:debajo-titulo>
        <v-tabs fixed-tabs background-color="#D7CCD7" v-model="tabSeleccionado" style="width: 100%" mobile-breakpoint="0" @change="actualizarTabla">
          <v-tab v-for="tab in arrayTabs" :key="tab.titulo"><v-icon class="mr-2">{{tab.icono}}</v-icon>{{ $t (tab.titulo) }}</v-tab>
        </v-tabs>
      </template>

      <template v-slot:accionesPersonalizadas="{item}">
        <v-icon v-if="item.est==9" small color="primary" class="mr-2" @click="abrirInforme (item)">mdi-file-eye-outline</v-icon>
        <v-icon v-if="item.est==9" small color="primary" class="mr-2" @click="descargarInforme (item)">mdi-download</v-icon>
      </template>

      <template v-slot:[`item.des`]="{ item }">
        <span :class="[claseCSSDescripcionInforme (item)]">{{ item.des }}</span>
        <v-progress-linear v-if="item.est == 3" color="blue darken-1" indeterminate rounded height="4"></v-progress-linear>
      </template>

      <template v-slot:[`item.ins`]="{ item }">
        <span style="font-style: italic">{{ item.ins }}</span>
      </template>

      <template v-slot:[`item.parapl`]="{ item }">
        <span style="font-size: 12px">{{ item.parapl }}</span>
      </template>

      <template v-slot:[`item.for`]="{ item }">
        <span style="white-space: nowrap">
          <v-icon v-if="item.for == 'PDF'">mdi-file-pdf-box</v-icon>
          <v-icon v-else-if="item.for == 'TXT'">mdi-text-box</v-icon>
          <v-icon v-else-if="item.for == 'HTML'">mdi-language-html5</v-icon>
          <v-icon v-else-if="item.for == 'CSV'">mdi-file-delimited</v-icon>
          <v-icon v-else-if="item.for == 'TSV'">mdi-file-delimited-outline</v-icon>

          <span v-else style="font-family: monospace">{{ item.for }}</span>
          <span v-if="item.tam > 0" class="ml-2" style="font-family: monospace">{{ Math.round(item.tam/1024) }} KB</span>
        </span>
      </template>

      <template v-slot:[`item.est__VT`]="{ item }">
        {{item.est__VT}}
        <span v-if="item.est != 9 && item.partot > 0" class="ml-2" style="font-family: monospace">({{ item.parrec }}/{{ item.partot }})</span>
      </template>

    </TablaDatosAPI>

    <VentanaNuevoInforme ref="vni" />

  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";
import VentanaNuevoInforme from "@/components/VentanaNuevoInforme.vue";

export default {
  components: { TablaDatosAPI,
                VentanaNuevoInforme },
  data: () => ({
    arrayTabs: [
      { titulo: "Hoy", icono: "", parametro: "filtroHoy" },
      { titulo: "Ayer", icono: "", parametro: "filtroAyer" },
      { titulo: "Últimos 7 días", icono: "", parametro: "filtroUltimos7dias" },
      { titulo: "(Todos)", icono: "", parametro: "" },
    ],
    tabSeleccionado: 0,
    manejadorNotificacionesInformesOperador: null
  }),
  computed: {
    parametros() {
      let aux = {};
      if (this.arrayTabs [this.tabSeleccionado].parametro)
        aux [this.arrayTabs [this.tabSeleccionado].parametro] = { valor: 1, descripcion: this.arrayTabs [this.tabSeleccionado].titulo };
      return aux;
    }
  },
  methods: {
    actualizarTabla(){
      this.$nextTick (() => {
        this.$refs.tablaInformes.actualizarDatosPorCambiosEnBusqueda();
      });
    },
    claseCSSDescripcionInforme (fila) {
      if (fila.est == 9 && !fila.lei)
        return "informe-no-leido";
      else if (fila.est == 3)
        return "informe-en-progreso";
      else if (fila.est == 0)
        return "informe-error";
    },
    nuevoInforme () {
      this.$refs.vni.abrirVentana ();
    },
    abrirInforme (informe) {
      if (informe.est == 9) {
        let url = process.env.VUE_APP_URL_BASE_BACKEND + "/descargar_informe?id_informe=" + informe.id_inf + "&accessToken=" + encodeURIComponent (this.$store.accessToken);
        window.open(url, '_blank').focus();
      }
    },
    descargarInforme (informe) {
      let url = process.env.VUE_APP_URL_BASE_BACKEND + "/descargar_informe?id_informe=" + informe.id_inf + "&descargar_fichero=1&accessToken=" + encodeURIComponent (this.$store.accessToken);
      window.open(url, '_blank').focus();
    },
    procesarNotificacionesInformesOperador () {
      if (this.$refs.tablaInformes) {
        this.tabSeleccionado = 0;
        this.actualizarTabla();
      }
    }
  },
  created() {
    this.manejadorNotificacionesInformesOperador = this.$sagabroker.anadirEscuchadorTema ("operador/*/notificaciones/informes", this.procesarNotificacionesInformesOperador);
    this.tabSeleccionado = this.$store.leer_preferencia ('tabSeleccionado', 0, 'informes');
  },
  watch: {
    tabSeleccionado() {
      this.$store.guardar_preferencia ('tabSeleccionado', this.tabSeleccionado, 0, 'informes');
    }
  },
  destroyed() {
    this.$sagabroker.eliminarEscuchadorTema (this.manejadorNotificacionesInformesOperador);
  }
};
</script>

<style>
.informe-no-leido {
  font-weight: bold;
}
.informe-en-progreso {
  opacity: 0.7;
}
.informe-error {
  color: #F44336;
}
</style>